import React from "react";
import { SvgIcon } from "@mui/material";

const SparklesIcon = (props) => (
  <SvgIcon {...props}>
    {/* main sparkle */}
    <path d="M12 2l1.8 4.5L18 8l-4.2 1.5L12 14l-1.8-4.5L6 8l4.2-1.5L12 2z" />

    {/* small sparkle top-right */}
    <path d="M18 2l.9 2.2L21 5l-2.1.8L18 8l-.9-2.2L15 5l2.1-.8L18 2z" />

    {/* small sparkle bottom-left */}
    <path d="M6 16l1.2 3L10 20l-2.8 1L6 24l-1.2-3L2 20l2.8-1L6 16z" />
  </SvgIcon>
);

export default SparklesIcon;